import * as autocomplete from './autocomplete.js';

const events = ['mouseenter', 'touchstart', 'focusin'];

function applyAddressAutocompleteEventListeners() {
  autocomplete.setupAutocomplete();

  events.forEach((eventName) =>
    getForms().forEach((form) =>
      form.addEventListener(eventName, loadMapsListener, {
        once: true,
        passive: true,
      })
    )
  );
}

const getForms = () =>
  Array.from(document.querySelectorAll('.autocomplete-us'))
    .map((el) => el.closest('form'))
    .filter(Boolean);

const removeMapsListeners = () =>
  events.forEach((eventName) =>
    getForms().forEach((form) =>
      form.removeEventListener(eventName, loadMapsListener)
    )
  );

const loadMapsListener = async () => {
  removeMapsListeners();
  await autocomplete.loadGmaps();
};

export { applyAddressAutocompleteEventListeners };
